import React from 'react'
import { Slide } from 'pure-react-carousel'
import { Carousel } from 'components/Slider'
import { ReviewItem } from './components/ReviewItem'
import { Container } from './styled'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { useCmsBlock } from 'lib/core/hooks'

export const Reviews = () => {
  const id = CMS_BLOCK.HOME_REVIEWS
  const cmsBlock = useCmsBlock({
    id,
    isLazy: false
  })
  const content = cmsBlock?.content

  if (!content) return null

  const reviewsParent = document.createElement('div')
  reviewsParent.innerHTML = content
  const reviewsElements = reviewsParent.querySelectorAll('#reviews')
  const jsonReviews = JSON.parse(reviewsElements[0]?.innerHTML)
  const reviews = Object.keys(jsonReviews).map(review => jsonReviews[review])

  return (
    <Container
      id={id}
    >
      <div>
        {reviews.length && (
          <Carousel
            title='Women Everywhere Are Loving Sofia & Grace.'
            child={reviews}
            renderChildren={(children: any[]) => {
              return children.map((child: any, index: number) => {
                return (
                  <Slide index={index} key={index}>
                    <ReviewItem points={child.rating} author={child.author} review={child.content} />
                  </Slide>
                )
              })
            }}
            autoPlay
            arrowsEnabled={reviews?.length > 1}
            fadeSides
            autoHeight
            dotsEnabled
          />
        )}
      </div>
    </Container>
  )
}
